import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

export const Wrapper = styled.div`
  scroll-snap-align: none center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 560px;
  margin-bottom: 220px;
  position: relative;

  ${mediaQuery.maxWidth.tablet} {
    margin-bottom: 120px;
    padding: 0;
    height: auto;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: row;
  gap: 7.625rem;
  max-width: 1240px;
  padding: 1rem;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;

export const Title = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 3rem;
  margin: 0;
  line-height: 100%;
  z-index: 1;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  gap: 2rem;

  ${mediaQuery.maxWidth.tablet} {
    display: flex;
    opacity: 1;
    width: 100%;
    padding: 0 2rem;
  }
`;

export const Text = styled.div`
  font-size: 20px;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  padding-top: 12px;
  padding-bottom: 8px;
`;

export const HighlightedTitle = styled.span`
  background: linear-gradient(90deg, #B866FF 0%, #F34675 59.91%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;

export const RemainingTitle = styled.span``;

export const Description = styled.div`
  color: rgba(255, 255, 255, 0.75);
  font-size: 20px;
  line-height: 32px;
`;

export const ImageContainer = styled.div`
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: center;


  ${mediaQuery.maxWidth.tablet} {
    width: 100%;
  }
`;

export const Image = styled.img`
  max-height: 560px;
  width: 100%;
  object-fit: contain;
`;